import { TextField, type TextFieldProps } from "@mui/material";
import { useEffect, useRef, useState } from "react";

export interface NumberInputProps {
    value: number;
    digits?: number;
    min?: number;
    max?: number;
    onChange: (value: number) => void;
}

export function NumberInput({
    value,
    digits = 2,
    min,
    max,
    onChange,
    ...textFieldProps
}: NumberInputProps & TextFieldProps): JSX.Element {
    const [textValue, setTextValue] = useState(value && value.toString());
    const lastValue = useRef(value && parseFloat(value.toFixed(digits)));

    const handleTextValueChange = (newValue: string) => {
        setTextValue(newValue);

        const cleanValue = newValue.replace(",", ".");
        const numValue = parseFloat(cleanValue);

        if (
            !cleanValue.match(/^\d+(\.\d+)?$/) ||
            (min && numValue < min) ||
            (max && numValue > max)
        ) {
            lastValue.current = null;
            onChange(null);
        } else {
            const parsedValue = parseFloat(numValue.toFixed(digits));
            lastValue.current = parsedValue;
            if (parsedValue !== value) {
                onChange(parsedValue);
            }
        }
    };

    useEffect(() => {
        if (value !== null && lastValue.current !== value && value !== undefined) {
            handleTextValueChange(value.toFixed(digits));
        }
    }, [value]);

    return (
        <TextField
            type="number"
            value={textValue ?? ""}
            required={true}
            onChange={(evt) => handleTextValueChange(evt.target.value)}
            {...textFieldProps}
        />
    );
}
